import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

function AddTransaction() {
  const [form, setForm] = useState({
    amount: "",
    description: "",
    category: ""
  });

  const [user, setUser] = useState(null);

  // ✅ loading state
  const [authLoading, setAuthLoading] = useState(true);

  // 🔐 Get logged-in user
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setAuthLoading(false); // ✅ done checking
    });

    return () => unsub();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) return;

    if (!form.amount || !form.description || !form.category) {
      alert("Fill all fields");
      return;
    }

    await addDoc(
      collection(db, "users", user.uid, "transactions"),
      {
        amount: Number(form.amount),
        description: form.description,
        category: form.category,
        createdAt: new Date()
      }
    );

    setForm({ amount: "", description: "", category: "" });
  };

  return (
  <div className="bg-[#111827]/80 backdrop-blur-md border border-slate-700/50 rounded-2xl p-5 shadow-xl">

    <h2 className="text-lg font-semibold text-white mb-4">
      ➕ Add Transaction
    </h2>

    {/* Auth State */}
    {authLoading ? (
      <p className="text-slate-400 text-sm">Checking login...</p>
    ) : !user ? (
      <p className="text-slate-400 text-sm">
        Please login to add transactions
      </p>
    ) : (

      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4"
      >

        {/* Amount */}
        <input
          type="number"
          placeholder="₹ Amount"
          value={form.amount}
          onChange={(e) =>
            setForm({ ...form, amount: e.target.value })
          }
          className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white placeholder-slate-400 
          focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
        />

        {/* Description */}
        <input
          placeholder="Description"
          value={form.description}
          onChange={(e) =>
            setForm({ ...form, description: e.target.value })
          }
          className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white placeholder-slate-400 
          focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
        />

        {/* Category */}
        <select
          value={form.category}
          onChange={(e) =>
            setForm({ ...form, category: e.target.value })
          }
          className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-slate-300 
          focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
        >
          <option value="">Select Category</option>
          <option>Food & Dining</option>
          <option>Groceries</option>
          <option>Transport</option>
          <option>Bills & Utilities</option>
          <option>Shopping</option>
          <option>Entertainment</option>
          <option>Health & Medical</option>
          <option>Education</option>
          <option>Transfers</option>
          <option>Others</option>
        </select>

        {/* Button */}
        <button
          type="submit"
          className="mt-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2.5 rounded-lg 
          transition-all duration-200 shadow-md hover:shadow-lg active:scale-95"
        >
          Add Transaction
        </button>

      </form>
    )}
  </div>
);
}

export default AddTransaction;